import api from '../utils/api';

export async function listTextFieldVersions({
  resourceType,
  resourceId,
  fieldName,
  limit = 20,
}) {
  const { data } = await api.get('/text-field-versions', {
    params: {
      resource_type: resourceType,
      resource_id: resourceId,
      field_name: fieldName,
      limit,
    },
  });
  return data;
}

export async function createTextFieldVersion({
  resourceType,
  resourceId,
  fieldName,
  content,
  source = 'ai_improve',
  metadata = {},
}) {
  const { data } = await api.post('/text-field-versions', {
    resource_type: resourceType,
    resource_id: resourceId,
    field_name: fieldName,
    content,
    source,
    metadata,
  });
  return data;
}

export async function restoreTextFieldVersion(versionId) {
  const { data } = await api.post(`/text-field-versions/${versionId}/restore`);
  return data;
}
